const Footer = (props) => {
  	return (
	    <div id="footer">
	    	<a href="https://github.com/flipdishbytes/recruiting/tree/main/Flipdish.Recruiting.FE">Flipdish.Recruiting.FE</a>
	    	<a href="mailto:developer@andreaciardi.com">Andrea Ciardi - developer@andreaciardi.com</a>
	    </div>
  	);
};

export default Footer;